import { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { Logo } from "./Logo";
import { useTheme } from "@/hooks/useTheme";

export function AuthHeader() {
  const { theme, toggleTheme } = useTheme();
  const [themeIconSpin, setThemeIconSpin] = useState(false);

  const handleToggleTheme = () => {
    setThemeIconSpin(true);
    toggleTheme();
    setTimeout(() => setThemeIconSpin(false), 500);
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border/40 bg-background/80 backdrop-blur-md">
      <div className="container h-16 flex items-center justify-between">
        <Logo showText markClassName="h-8" textClassName="text-xl" />

        <div className="flex items-center gap-2">
          <button
            onClick={handleToggleTheme}
            className="h-10 w-10 min-h-[44px] min-w-[44px] flex items-center justify-center rounded-full text-foreground/70 hover:bg-accent hover:text-foreground transition-colors active:scale-95"
            aria-label="Toggle theme"
            title={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
          >
            <span
              className={
                themeIconSpin ? "theme-icon-spin inline-flex" : "inline-flex"
              }
              aria-hidden="true"
            >
              {theme === "light" ? (
                <Moon className="h-[18px] w-[18px]" />
              ) : (
                <Sun className="h-[18px] w-[18px]" />
              )}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
